export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: isMobile ? '100%' : 'auto',
  height: isMobile ? '100%' : 'auto',
  padding: isMobile ? '0.75rem 1.25rem 0.55rem' : '0.75rem 1rem 0.4rem',
});
